import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card'
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';

import { fetchProfile, updateProfile } from './action';

const OwnerProfile = (props) => {
  const { profile } = props;

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    petType: null,
    petSize: null,
    address: '',
    passport: null,
    driverLicense: null,
  });
  const [formEntryError, setFormEntryError] = useState({
    firstNameError: null,
    lastNameError: null,
    addressError: null,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProfile());
  }, [dispatch]);

  useEffect(() => {
    setFormData({
      ...formData,
      ...profile,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(profile)]);

  const [agreedToComm, setAgreedToComm] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const petTypes = [
    { label: 'Cat', value: 'cat' },
    { label: 'Dog', value: 'dog' },
  ];

  const petSizes = [
    { label: 'Big' },
    { label: 'Small' },
  ];

  const handleOnChange = (key, value) => {
    const errorKey = `${key}Error`;
    setFormEntryError({
      ...formEntryError,
      [errorKey]: null,
    });
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const validateFormData = () => {
    const error = {
      firstNameError: null,
      lastNameError: null,
      addressError: null,
    };
    if (!formData.firstName) {
      error.firstNameError = 'First name is required';
    }
    if (!formData.lastName) {
      error.lastNameError = 'Last name is required';
    }
    if (!formData.address) {
      error.addressError = 'Address is required';
    }
    setFormEntryError(error);
    return Object.keys(error).reduce(
      (prevVal, key) => prevVal && error[key] === null,
      true,
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const isDataValid = validateFormData();
    if (!isDataValid) return;
    dispatch(updateProfile(formData));
  };

  return (
    
    <Container
    
      component="main"
      minWidth="md"
      // sx={{
      //   height: 'calc(100vh - 100px)',
      //   display: 'flex',
      //   alignItems: 'center',
      // }}
    >
     <Card sx={{ paddingX: "2rem", paddingY: "3rem" , marginTop: "1rem"}}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h4">
          Update Profile
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', mt: 4 }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '1em',
              width: '100%',
            }}
          >
            <TextField
              id="firstName"
              label="First name"
              name="firstName"
              autoComplete="given-name"
              autoFocus
              value={formData.firstName}
              onChange={e => handleOnChange(e.target.name, e.target.value)}
              error={formEntryError.firstNameError !== null}
              helperText={formEntryError.firstNameError}
            />
            <TextField
              id="lastName"
              label="Last name"
              name="lastName"
              autoComplete="family-name"
              value={formData.lastName}
              onChange={e => handleOnChange(e.target.name, e.target.value)}
              error={formEntryError.lastNameError !== null}
              helperText={formEntryError.lastNameError}
            />
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '0.5em',
              width: '100%',
              marginTop: 12,
            }}
          >
            <TextField
              disabled
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              value={formData.email}
            />
            <TextField
              disabled
              fullWidth
              type="password"
              id="password"
              label="Password"
              name="password"
              value={formData.password}
            />
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '0.5em',
              width: '100%',
              marginTop: 12,
            }}
          >
            <Autocomplete
              required
              id="pet-type-input"
              options={petTypes}
              getOptionLabel={option => option.label}
              isOptionEqualToValue={(op, selected) => op.value === selected.value}
              renderInput={(params) => <TextField {...params} label="Pet Type" />}
              onChange={(_, selectedValue) => handleOnChange('petType', selectedValue)}
            />
            <Autocomplete
              required
              id="pet-size-input"
              options={petSizes}
              getOptionLabel={option => option.label}
              isOptionEqualToValue={(op, selected) => op.value === selected.value}
              renderInput={(params) => <TextField {...params} label="Pet Size" />}
              onChange={(_, selectedValue) => handleOnChange('petSize', selectedValue)}
            />
          </div>
          <TextField
            id="address-input"
            label="Main address"
            name="address"
            multiline
            rows={3}
            fullWidth
            sx={{ mt: 1.5 }}
            value={formData.address}
            onChange={e => handleOnChange(e.target.name, e.target.value)}
            error={formEntryError.addressError !== null}
            helperText={formEntryError.addressError}
          />
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '1em',
              width: '100%',
              marginTop: 16,
            }}
          >
            <div>
              <Button
                variant="contained"
                component="label"
                fullWidth
                color="secondary"
              >
                Upload Passport
                <input
                  type="file"
                  name="passport"
                  hidden
                  onChange={e => handleOnChange(e.target.name, e.target.files[0])}
                />
              </Button>
              <Typography
                component="small"
                variant="small"
                sx={{ display: 'block', mt: 1 }}
              >
                {formData.passport?.name}
              </Typography>
            </div>
            <div>
              <Button
                variant="contained"
                component="label"
                fullWidth
                color="secondary"
              >
                Upload Driver's License
                <input
                  type="file"
                  name="driverLicense"
                  hidden
                  onChange={e => handleOnChange(e.target.name, e.target.files[0])}
                />
              </Button>
              <Typography
                component="small"
                variant="small"
                sx={{ display: 'block', mt: 1 }}
              >
                {formData.driverLicense?.name}
              </Typography>
            </div>
          </div>
          {(formEntryError.passportError || formEntryError.driverLicenseError) && (
            <Alert severity="error" sx={{ mt: 2 }}>
              <div>{formEntryError.passportError}</div>
              <div>{formEntryError.driverLicenseError}</div>
            </Alert>
          )}
          <FormGroup sx={{ mt: 1.5 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={agreedToComm}
                  value={agreedToComm}
                  onChange={e => setAgreedToComm(e.target.checked)}
                />
              }
              label="I agree to communications from DogeCare"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={agreedToTerms}
                  value={agreedToTerms}
                  onChange={e => setAgreedToTerms(e.target.checked)}
                />
              }
              label="I agree to Terms & Conditions"
            />
          </FormGroup>
          {/* {formSubmitError && (
            <Alert severity="error" sx={{ mt: 1 }}>{formSubmitError}</Alert>
          )} */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: 24,
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="success"
              disabled={!agreedToComm || !agreedToTerms}
            >
              Save Changes
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="error"
            >
              Delete Profile
            </Button>
            <Button
              type="submit"
              variant="contained"
            >
              Change Password
            </Button>
          </div>
        </Box>
      </Box>
      </Card>
    </Container>
    
  );
};

export default OwnerProfile;
